"use strict";

const { CrossAppEvent, dispatchCrossAppEvent } = require("./cross-app/events");

const ClinicalPort = {
  add: function (app) {
    // Track if core-ready has been dispatched
    if (typeof window.__coreReadyDispatched === "undefined") {
      window.__coreReadyDispatched = false;
    }

    if (app.ports.dispatchLoadClinicalPort) {
      app.ports.dispatchLoadClinicalPort.subscribe(async () => {
        // Prevent dispatching core-ready multiple times
        if (window.__coreReadyDispatched) return;

        window.__coreReadyDispatched = true;

        try {
          // Load EMR assets and wait for completion
          if (
            window.loadEMRAssets &&
            typeof window.loadEMRAssets === "function"
          ) {
            await window.loadEMRAssets();
          }

          dispatchCrossAppEvent(CrossAppEvent.CORE_READY);
        } catch (error) {
          // Reset flag on error to allow retry
          window.__coreReadyDispatched = false;
          throw error;
        }
      });
    }
  },
};

module.exports = ClinicalPort;
